import { Dispatch, SetStateAction, useCallback } from 'react';
import { Dismissed } from '@/srp/Banners/PromoBanner/constants';
import tagId from '~/constants/common/TagId';
import { COOKIES } from '~/constants/srp';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import { useAppliedFiltersContext } from '~/context/common/AppliedFiltersContext';
import { PromoBanners } from '../constants';
import { getBannerName, setBannerDismissedCookie } from '../utils';

export default function useHandleBannerClicks(
  setIsPriceDropDismissed: Dispatch<SetStateAction<number>>
) {
  const { updateListFilter } = useAppliedFiltersContext();
  const trackEvent = useTrackEvent();

  const handleShopAllClick = useCallback(() => {
    setIsPriceDropDismissed(Dismissed.Banner);
    updateListFilter({
      filterKey: 'tagIds',
      value: tagId.PriceDrop.toString()
    });
  }, [setIsPriceDropDismissed, updateListFilter]);

  const handleCloseClick = useCallback(() => {
    trackEvent('Banner', {
      category: getBannerName(PromoBanners.PriceDrop),
      label: 'Close'
    });
    setBannerDismissedCookie(
      PromoBanners.PriceDrop,
      COOKIES.dismissedNewPriceBanner
    );
    setIsPriceDropDismissed(Dismissed.Banner);
  }, [setIsPriceDropDismissed, trackEvent]);

  return { handleShopAllClick, handleCloseClick };
}
